import { signupApi } from './signup'

const linkTokenApi = signupApi.injectEndpoints({
  endpoints: (builder) => ({
    getLinkToken: builder.query<{ linkToken: string }, string>({
      query: (quoteId) => ({
        url: `link/token/${quoteId}/create`,
        method: 'GET',
      }),
    }),
  }),
})

const { useGetLinkTokenQuery } = linkTokenApi

export { useGetLinkTokenQuery }
